module.exports = __webpack_public_path__ + "media/images/bet__wrongMarker@2x-0886a659455cfabff10cc08d27fb603e.png";